export enum EnumMyCourseMenu {
  /** 林曦老师亲授 */
  Teach = 'teach',
  /** 林曦老师监制 */
  Product = 'product',
  /** 线下课 */
  Offline = 'offline'
}

export enum EnumMyStudyMenu {
  /** 作业 */
  Homework = 'homework',
  /** 作品 */
  Reward = 'reward',
  /** 日常 */
  Daily = 'daily',
  /** 收藏 */
  Collect = 'collect'
}

export enum EnumMyAccountMenu {
  /** 订单 */
  Order = 'order',
  /** 笔山 */
  Bishan = 'bishan',
  /** 桐板儿 */
  Coin = 'coin',
  /** 卡劵 */
  Packs = 'packs',
  /** 兑换 */
  Exchange = 'exchange'
}

export enum EnumMySettingsMenu {
  /**
   * 个人资料
   */
  Myself = 'myself',
  /**
   * 通知消息
   */
  Notice = 'notice',
  /**
   * 账号设置
   */
  Account = 'account'
}

export enum EnumMyAccountExchange {
  /** 卡劵列表 */
  List = 'list',
  /** 卡劵详情 */
  Detail = 'detail',
  /** 兑换记录 - 此处做切换界面用 */
  Record = 6
}

// 我的账户 - 卡劵筛选项
export enum EnumMyAccountPacksFilter {
  /** 全部 */
  All = 0,
  /** 福利劵 */
  WelfareCoupon = 1,
  /** 文房劵 */
  WenfangCoupon = 2,
  /** 伴学卡 */
  CompanionCard = 3,
  /** 已使用 */
  Used = 4,
  /** 已过期 */
  Expired = 5
}

// 个人主页tabs
export enum EnumMyTabs {
  /** 我的教室 */
  Index = '1',
  /** 我的课程 */
  Course = '2',
  /** 我的学习 */
  Study = '3',
  /** 我的账户 */
  Account = '4',
  /** 账号设置 */
  Settings = '5',
  /** 他人主页 */
  Center = '6'
}

export enum EnumMyAccountCount {
  /** 订单 */
  Order = 'order',
  /** 笔山 */
  Bishan = 'bishan',
  /** 桐板儿 */
  Coin = 'coin',
  /** 卡劵 */
  Packs = 'packs'
}

// 微信扫码弹窗类型枚举
export enum EnumWxImgPopType {
  Show = 'show',
  Day = 'day',
  Self = 'self'
}
